import { axiosPost, axiosPostForm1  } from '../../../../../request/http';

 const prexfix = global.$config.api.apiUrl;
 
 // 查询投诉信息列表
 export const GetSuggestList = (data) => {
   const params = {
     baseUrl: prexfix,
     data: data
   }
   return axiosPost(`/member-api/member/suggestList `, params)
 };
 
 // 查询投诉详情
 export const GetSuggestDetail = (data) => {
   const params = {
     baseUrl: prexfix,
     data: data
   }
   return axiosPost(`/member-api/member/suggestDetail`, params)
 };

// 查询投诉详情
export const GetSuggestDetailForm = (data) => {
  return axiosPostForm1(`/member-api/member/suggestDetail`, data)
};

 // 投诉处理
 export const SuggestUpdate = (data) => {
   const params = {
     baseUrl: prexfix,
     data: data
   }
   return axiosPost(`/member-api/member/suggestUpdate`, params)
 };
 
 // 获取投诉类型
 export const FindSDictionaryByGroupCode = (data) => {
     const params = {
       baseUrl: prexfix,
       data: data
     }
     return axiosPost(`/common-api/common/findSDictionaryByGroupCode`, params)
   };
 
 let ComplaintApi = {
    GetSuggestList,
    GetSuggestDetail,
    SuggestUpdate,
    FindSDictionaryByGroupCode,
    GetSuggestDetailForm
  };
  
  export default ComplaintApi;